export default __webpack_public_path__ + "static/media/239.1b2df582.jpg";